/* ============================================================
   MES MÉMOIRES — script.js
   ============================================================ */

'use strict';

// ── 1. NAV: scroll sticky + hamburger ────────────────────────
(function initNav() {
  const nav       = document.getElementById('nav');
  const toggle    = document.getElementById('navToggle');
  const links     = document.getElementById('navLinks');
  const navLinks  = document.querySelectorAll('.nav__link');

  if (!nav || !toggle || !links) return;
  if (toggle.dataset.navBound === 'true') return;
  toggle.dataset.navBound = 'true';
  toggle.setAttribute('aria-expanded', 'false');

  // Sticky on scroll
  const onScroll = () => {
    if (window.scrollY > 60) {
      nav.classList.add('scrolled');
    } else {
      nav.classList.remove('scrolled');
    }
  };
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  // Hamburger toggle
  toggle.addEventListener('click', () => {
    const isOpen = links.classList.toggle('open');
    toggle.classList.toggle('open', isOpen);
    toggle.setAttribute('aria-expanded', isOpen);
    document.body.style.overflow = isOpen ? 'hidden' : '';
  });

  // Close on link click
  links.querySelectorAll('a').forEach(link => {
    link.addEventListener('click', () => {
      links.classList.remove('open');
      toggle.classList.remove('open');
      toggle.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    });
  });

  // Active link on scroll
  const sections = document.querySelectorAll('section[id]');

  const highlightNav = () => {
    const scrollPos = window.scrollY + 120;
    sections.forEach(section => {
      const top    = section.offsetTop;
      const height = section.offsetHeight;
      const id     = section.getAttribute('id');
      const link   = document.querySelector(`.nav__link[href="#${id}"]`);

      if (link) {
        if (scrollPos >= top && scrollPos < top + height) {
          navLinks.forEach(l => l.classList.remove('active'));
          link.classList.add('active');
        }
      }
    });
  };
  window.addEventListener('scroll', highlightNav, { passive: true });
})();

// Prefill contact form from the custom order selector.
(function initContactPrefill() {
  function ready(fn){
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  ready(function(){
    var form = document.getElementById('contactForm');
    if (!form) return;
    var params = new URLSearchParams(window.location.search);
    var resume = params.get('resume');
    if (!resume) return;

    var subject = form.querySelector('#subject');
    var message = form.querySelector('#message');
    if (subject && !subject.value) subject.value = 'sur-mesure';
    if (message && !message.value) {
      message.value = [
        'Bonjour,',
        '',
        'Je souhaite avancer avec cette sélection Mes Mémoires :',
        resume,
        '',
        'Pouvez-vous me confirmer la suite ?'
      ].join('\n');
    }
  });
})();


// ── 2. SCROLL REVEAL (Intersection Observer) ─────────────────
(function initScrollReveal() {
  const preferReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (preferReducedMotion) {
    // Show everything instantly if motion is reduced
    document.querySelectorAll('[data-animate]').forEach(el => {
      el.classList.add('in-view');
    });
    return;
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const el    = entry.target;
        const delay = parseInt(el.dataset.delay || 0, 10);

        setTimeout(() => {
          el.classList.add('in-view');
        }, delay);

        observer.unobserve(el);
      }
    });
  }, {
    threshold:  0.12,
    rootMargin: '0px 0px -40px 0px'
  });

  document.querySelectorAll('[data-animate]').forEach(el => {
    observer.observe(el);
  });
})();


// ── 3. HERO: parallax on scroll ──────────────────────────────
(function initParallax() {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (window.innerWidth < 768) return; // Skip on mobile

  const hero = document.querySelector('.hero');
  if (!hero) return;

  window.addEventListener('scroll', () => {
    const scrollY  = window.scrollY;
    const maxScroll = window.innerHeight;
    const progress  = Math.min(scrollY / maxScroll, 1);
    hero.style.backgroundPositionY = `calc(40% + ${progress * 60}px)`;
  }, { passive: true });
})();


// ── 4. AUDIO PLAYER (real HTML5 audio) ──────────────────────────────
(function initAudioPlayer() {
  const playBtn     = document.getElementById('playBtn');
  const wave        = document.getElementById('audioWave');
  const progressBar = document.getElementById('progressBar');

  if (!playBtn || !wave || !progressBar) return;

  // Create real audio element
  const audio = new Audio(window.MEMOIRES_ASSETS && window.MEMOIRES_ASSETS.narration ? window.MEMOIRES_ASSETS.narration : 'assets/audio/narration-memoires.mp3');
  audio.preload = 'metadata';

  // Generate wave bar heights
  const bars = wave.querySelectorAll('span');
  bars.forEach(bar => {
    const h = Math.floor(Math.random() * 26) + 6;
    bar.style.setProperty('--bar-height', `${h}px`);
    bar.style.height = '6px';
  });

  const setPlayIcon = () => {
    playBtn.querySelector('svg').innerHTML = `
      <circle cx="28" cy="28" r="26" fill="none" stroke="#c9a84c" stroke-width="1.5"/>
      <polygon points="23,18 23,38 40,28" fill="#c9a84c"/>`;
    playBtn.setAttribute('aria-label', "Lire l'exemple audio");
  };

  const setPauseIcon = () => {
    playBtn.querySelector('svg').innerHTML = `
      <circle cx="28" cy="28" r="26" fill="none" stroke="#c9a84c" stroke-width="1.5"/>
      <rect x="18" y="17" width="5" height="22" rx="2" fill="#c9a84c"/>
      <rect x="27" y="17" width="5" height="22" rx="2" fill="#c9a84c"/>`;
    playBtn.setAttribute('aria-label', 'Mettre en pause');
  };

  audio.addEventListener('timeupdate', () => {
    if (audio.duration) {
      const pct = (audio.currentTime / audio.duration) * 100;
      progressBar.style.width = pct + '%';
    }
  });

  audio.addEventListener('play', () => {
    wave.classList.add('playing');
    bars.forEach(b => b.style.removeProperty('height'));
    setPauseIcon();
  });

  audio.addEventListener('pause', () => {
    wave.classList.remove('playing');
    bars.forEach(b => b.style.height = '6px');
    setPlayIcon();
  });

  audio.addEventListener('ended', () => {
    wave.classList.remove('playing');
    bars.forEach(b => b.style.height = '6px');
    progressBar.style.width = '0%';
    setPlayIcon();
  });

  playBtn.addEventListener('click', () => {
    if (audio.paused) { audio.play(); } else { audio.pause(); }
  });

  // Allow clicking progress bar to seek
  const progressWrap = progressBar.parentElement;
  if (progressWrap) {
    progressWrap.style.cursor = 'pointer';
    progressWrap.addEventListener('click', (e) => {
      const rect = progressWrap.getBoundingClientRect();
      const ratio = (e.clientX - rect.left) / rect.width;
      if (audio.duration) { audio.currentTime = ratio * audio.duration; }
    });
  }
})();


// ── 5. CONTACT FORM ──────────────────────────────────────────
(function initContactForm() {
  const form    = document.getElementById('contactForm');
  const success = document.getElementById('formSuccess');

  if (!form) return;

  form.addEventListener('submit', async (e) => {
    e.preventDefault();

    const name    = form.querySelector('#name').value.trim();
    const email   = form.querySelector('#email').value.trim();
    const message = form.querySelector('#message').value.trim();
    const subjectField = form.querySelector('#subject');
    const subject = subjectField && subjectField.value ? subjectField.options[subjectField.selectedIndex].text : 'Demande Mes Mémoires';

    // Simple validation
    if (!name || !email || !message) {
      shakeForm(form);
      return;
    }

    if (!isValidEmail(email)) {
      shakeField(form.querySelector('#email'));
      return;
    }

    const btn = form.querySelector('button[type="submit"]');
    const emailTo = form.dataset.email || 'contact@mesmemoires.fr';
    const endpoint = (form.getAttribute('data-endpoint') || form.getAttribute('action') || '').trim();
    const payload = {
      name,
      email,
      subject,
      message,
      source: window.location.href,
      createdAt: new Date().toISOString()
    };

    btn.textContent = 'Envoi en cours...';
    btn.disabled = true;

    if (endpoint && endpoint !== '#' && !endpoint.startsWith('mailto:')) {
      try {
        const response = await fetch(endpoint, {
          method: form.getAttribute('data-method') || form.getAttribute('method') || 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(payload)
        });
        if (!response.ok) throw new Error('Form endpoint error');
        form.reset();
        showSuccess('Votre message a bien été transmis. Nous vous répondrons dans les 48 heures.');
        btn.textContent = 'Envoyer le message';
        btn.disabled = false;
        return;
      } catch (error) {
        console.warn('Contact form endpoint failed, falling back to mailto.', error);
      }
    }

    const mailBody = [
      'Bonjour Mes Mémoires,',
      '',
      'Nom : ' + name,
      'Email : ' + email,
      'Sujet : ' + subject,
      '',
      'Message :',
      message
    ].join('\n');
    const mailto = 'mailto:' + encodeURIComponent(emailTo) +
      '?subject=' + encodeURIComponent('Demande depuis le site - ' + subject) +
      '&body=' + encodeURIComponent(mailBody);

    btn.textContent = 'Ouverture de votre messagerie...';
    window.location.href = mailto;

    window.setTimeout(() => {
      btn.textContent = 'Envoyer le message';
      btn.disabled    = false;
      showSuccess('Votre message est prêt dans votre messagerie. Il vous reste à l’envoyer pour que nous puissions vous répondre.');
    }, 700);
  });

  function showSuccess(text) {
    if (!success) return;
    success.innerHTML = '<span aria-hidden="true">✦</span> ' + text;
    success.classList.add('visible');
    setTimeout(() => success.classList.remove('visible'), 7000);
  }

  function isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  function shakeField(field) {
    if (!field) return;
    field.style.borderColor = '#c0392b';
    field.style.animation   = 'none';
    field.offsetHeight; // reflow
    field.style.animation   = 'shake 0.4s ease';
    field.addEventListener('animationend', () => {
      field.style.animation = '';
    }, { once: true });

    // Reset after focus
    field.addEventListener('focus', () => {
      field.style.borderColor = '';
    }, { once: true });
  }

  function shakeForm(form) {
    // Highlight empty required fields
    ['name', 'email', 'message'].forEach(id => {
      const field = form.querySelector(`#${id}`);
      if (field && !field.value.trim()) {
        shakeField(field);
      }
    });
  }
})();


// ── 6. NEWSLETTER FORM ───────────────────────────────────────
(function initNewsletter() {
  const forms = document.querySelectorAll('.newsletter-form');

  forms.forEach(form => {
    const input = form.querySelector('.newsletter-input');
    const btn   = form.querySelector('.btn');

    if (!btn) return;

    btn.addEventListener('click', async () => {
      if (!input || !input.value.trim()) {
        input.focus();
        return;
      }

      if (!isValidEmail(input.value.trim())) {
        input.focus();
        return;
      }

      let status = form.querySelector('.newsletter-status');
      if (!status) {
        status = document.createElement('p');
        status.className = 'newsletter-status';
        status.setAttribute('aria-live', 'polite');
        form.appendChild(status);
      }

      const email = input.value.trim();
      const endpoint = (form.getAttribute('data-endpoint') || form.getAttribute('action') || '').trim();

      btn.disabled = true;
      btn.textContent = 'Inscription...';

      if (endpoint && endpoint !== '#' && !endpoint.startsWith('mailto:')) {
        try {
          const response = await fetch(endpoint, {
            method: form.getAttribute('data-method') || form.getAttribute('method') || 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({
              email,
              source: window.location.href,
              createdAt: new Date().toISOString()
            })
          });
          if (!response.ok) throw new Error('Newsletter endpoint error');
          status.textContent = 'Votre inscription a bien été prise en compte.';
          input.value = '';
          btn.textContent = "S'inscrire";
          btn.disabled = false;
          return;
        } catch (error) {
          console.warn('Newsletter endpoint failed, falling back to mailto.', error);
        }
      }

      const mailto = 'mailto:contact@mesmemoires.fr?subject=' +
        encodeURIComponent('Inscription newsletter Mes Mémoires') +
        '&body=' + encodeURIComponent('Bonjour,\n\nJe souhaite inscrire cette adresse à la newsletter Mes Mémoires : ' + email);
      window.location.href = mailto;
      status.textContent = 'Votre demande d’inscription est prête dans votre messagerie.';
      input.value = '';
      btn.textContent = "S'inscrire";
      btn.disabled = false;
    });
  });

  function isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }
})();


// ── 7. SMOOTH SCROLL polyfill for older browsers ─────────────
(function initSmoothScroll() {
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      const target = document.querySelector(this.getAttribute('href'));
      if (!target) return;

      // Native smooth scroll handles this in modern browsers
      // This is a fallback for older ones
      if (!CSS.supports('scroll-behavior', 'smooth')) {
        e.preventDefault();
        const targetY = target.getBoundingClientRect().top + window.scrollY - 72;
        window.scrollTo({ top: targetY, behavior: 'smooth' });
      }
    });
  });
})();


// ── 8. FEATURE CARDS: stagger on scroll ──────────────────────
(function initCardStagger() {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const cards = document.querySelectorAll('.feature-card, .corr-item, .testimonial-card');

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry, i) => {
      if (entry.isIntersecting) {
        const el    = entry.target;
        const delay = parseInt(el.dataset.delay || 0, 10);

        setTimeout(() => {
          el.style.opacity   = '1';
          el.style.transform = 'translateY(0)';
        }, delay);

        observer.unobserve(el);
      }
    });
  }, { threshold: 0.08 });

  cards.forEach(card => {
    // Set initial state if not already handled by data-animate
    if (!card.hasAttribute('data-animate')) {
      card.style.opacity   = '0';
      card.style.transform = 'translateY(20px)';
      card.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
      observer.observe(card);
    }
  });
})();


// ── 9. CSS ANIMATION: shake keyframe injection ────────────────
(function injectShakeKeyframe() {
  const style = document.createElement('style');
  style.textContent = `
    @keyframes shake {
      0%, 100% { transform: translateX(0); }
      20%       { transform: translateX(-6px); }
      40%       { transform: translateX(6px); }
      60%       { transform: translateX(-4px); }
      80%       { transform: translateX(4px); }
    }
  `;
  document.head.appendChild(style);
})();


// ── 10. PAGE LOAD: fade in ────────────────────────────────────
(function initPageLoad() {
  const showPage = () => { document.body.style.opacity = '1'; };
  document.body.style.opacity = '0';
  document.body.style.transition = 'opacity 0.5s ease';

  window.addEventListener('load', showPage, { once: true });
  document.addEventListener('DOMContentLoaded', () => requestAnimationFrame(showPage), { once: true });
  window.setTimeout(showPage, 900);

  // Fallback if load event already fired
  if (document.readyState !== 'loading') requestAnimationFrame(showPage);
})();

// ── 11. SCROLL TO TOP BUTTON ──────────────────────────────────
(function initScrollTop() {
  const btn = document.getElementById('scrollTop');
  if (!btn) return;

  window.addEventListener('scroll', () => {
    btn.classList.toggle('visible', window.scrollY > 400);
  }, { passive: true });

  btn.addEventListener('click', () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });
})();

// ── PATCH V7 : lightbox stable + choix format AMP/FIV ─────────────────────
(function patchV7ProductInteractions(){
  function ready(fn){
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  ready(function(){
    var overlay = document.getElementById('lbOverlay');
    var lbImg   = document.getElementById('lbImg');
    var lbPrev  = document.getElementById('lbPrev');
    var lbNext  = document.getElementById('lbNext');
    var lbClose = document.getElementById('lbClose');
    if (!overlay || !lbImg) return;

    var srcs = [];
    var alts = [];
    var cur = 0;

    function validSrc(img){
      return img && (img.getAttribute('src') || img.currentSrc || img.src);
    }
    function normalizeImgs(imgs){
      var seen = new Set();
      return Array.from(imgs || []).map(function(img){
        var src = validSrc(img);
        return { src: src, alt: img.alt || '' };
      }).filter(function(item){
        if (!item.src || seen.has(item.src)) return false;
        seen.add(item.src);
        return true;
      });
    }
    function show(index){
      if (!srcs.length) return;
      cur = ((index % srcs.length) + srcs.length) % srcs.length;
      lbImg.style.opacity = '0';
      var nextSrc = srcs[cur];
      var nextAlt = alts[cur] || '';
      var loader = new Image();
      loader.onload = function(){
        lbImg.src = nextSrc;
        lbImg.alt = nextAlt;
        requestAnimationFrame(function(){ lbImg.style.opacity = '1'; });
      };
      loader.onerror = function(){
        lbImg.src = nextSrc;
        lbImg.alt = nextAlt;
        lbImg.style.opacity = '1';
      };
      loader.src = nextSrc;
      if (lbPrev) lbPrev.style.display = srcs.length > 1 ? '' : 'none';
      if (lbNext) lbNext.style.display = srcs.length > 1 ? '' : 'none';
    }
    function openWithImages(imgs){
      var items = normalizeImgs(imgs);
      if (!items.length) return;
      srcs = items.map(function(i){ return i.src; });
      alts = items.map(function(i){ return i.alt; });
      show(0); // obligatoire : toujours la couverture / première image
      overlay.classList.add('open');
      document.body.style.overflow = 'hidden';
    }
    function close(){
      overlay.classList.remove('open');
      document.body.style.overflow = '';
      lbImg.src = '';
    }

    // Capture avant les anciens scripts inline : ça évite les écrans noirs et force l'image 1.
    document.addEventListener('click', function(e){
      var ampTrigger = e.target.closest('.amp-main-image, .amp-more-visuals');
      if (ampTrigger) {
        var gallery = ampTrigger.closest('.amp-gallery, .amp-visual');
        if (gallery) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          var imgs = gallery.querySelectorAll('.amp-hidden-gallery img');
          if (!imgs.length) imgs = gallery.querySelectorAll('.amp-main-image');
          openWithImages(imgs);
        }
        return;
      }
      var collImg = e.target.closest('.coll-carousel .coll-slide img');
      if (collImg) {
        var carousel = collImg.closest('.coll-carousel');
        if (carousel) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          carousel.querySelectorAll('.coll-slide img').forEach(function(img){ img.setAttribute('loading','eager'); });
          openWithImages(carousel.querySelectorAll('.coll-slide img'));
        }
      }
    }, true);

    if (lbClose) lbClose.addEventListener('click', function(e){ e.preventDefault(); e.stopPropagation(); close(); }, true);
    if (lbPrev) lbPrev.addEventListener('click', function(e){ e.preventDefault(); e.stopPropagation(); show(cur - 1); }, true);
    if (lbNext) lbNext.addEventListener('click', function(e){ e.preventDefault(); e.stopPropagation(); show(cur + 1); }, true);
    overlay.addEventListener('click', function(e){ if (e.target === overlay) close(); }, true);

    // Force visuel principal des carrousels sur la première image au chargement.
    document.querySelectorAll('.coll-carousel').forEach(function(carousel){
      var slides = Array.from(carousel.querySelectorAll('.coll-slide'));
      slides.forEach(function(slide, i){
        slide.classList.toggle('active', i === 0);
        slide.style.position = i === 0 ? '' : 'absolute';
        slide.style.inset = i === 0 ? '' : '0';
      });
      var dots = carousel.querySelectorAll('.coll-dot');
      dots.forEach(function(dot, i){ dot.classList.toggle('active', i === 0); });
    });

    // Choix de format clairement sélectionnable + lien panier varianté.
    document.querySelectorAll('.amp-format-zone').forEach(function(zone){
      var cards = Array.from(zone.querySelectorAll('.amp-format-card'));
      var product = zone.closest('.amp-product');
      var buy = product ? product.querySelector('.amp-buy .btn') : null;
      function cardType(card){
        var t = (card.textContent || '').toLowerCase();
        if (t.indexOf('pack') !== -1 || t.indexOf('duo') !== -1) return 'pack-duo';
        if (t.indexOf('grand') !== -1) return 'grand-format';
        return 'petit-format';
      }
      function select(card){
        cards.forEach(function(c){
          c.classList.remove('is-selected');
          c.setAttribute('aria-pressed','false');
        });
        card.classList.add('is-selected');
        card.setAttribute('aria-pressed','true');
        if (buy) {
          var base = buy.getAttribute('data-base-href') || buy.getAttribute('href') || '/products/mes-memoires-amp-fiv';
          buy.setAttribute('data-base-href', base.split('?')[0]);
          buy.setAttribute('href', base.split('?')[0] + '?format=' + encodeURIComponent(cardType(card)));
        }
      }
      cards.forEach(function(card, i){
        card.setAttribute('role','button');
        card.setAttribute('tabindex','0');
        card.setAttribute('aria-pressed','false');
        card.addEventListener('click', function(){ select(card); });
        card.addEventListener('keydown', function(ev){
          if (ev.key === 'Enter' || ev.key === ' ') { ev.preventDefault(); select(card); }
        });
        if (i === 0 && !cards.some(function(c){ return c.classList.contains('is-selected'); })) select(card);
      });
    });
  });
})();

// Navigation and direct cart flow helpers.
(function initMesMemoiresCartFlow(){
  function ready(fn){
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  function normalize(value){
    return String(value || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();
  }

  function selectedFormatFromUrl(url){
    try {
      return new URL(url, window.location.origin).searchParams.get('format') || '';
    } catch (error) {
      return '';
    }
  }

  var fixedPaidVariantIds = {
    'mes-memoires-dentrepreneur-tropical': 40068106387644,
    'mes-memoires-dentrepreneur-marbre': 40068099342524,
    'mes-memoires-de-grand-pere-tropical': 40068134240444,
    'mes-memoires-de-grand-pere-marbre': 40068131356860,
    'mes-memoires-de-grand-mere-tropical': 40068127064252,
    'mes-memoires-de-grand-mere-marbre': 40068120281276,
    'mes-memoires-de-papa-tropical': 40068157472956,
    'mes-memoires-de-papa-marbre': 40068155211964,
    'mes-memoires-de-maman-tropical-rose': 40068151771324,
    'mes-memoires-de-maman-tournesols': 40068145184956,
    'mes-memoires-de-maman-tropical-perroquets': 40068137844924,
    'mes-memoires-de-maman-jungle': 40068137844924
  };

  var canonicalProductHandles = {
    'mes-memoires-de-maman-jungle': 'mes-memoires-de-maman-tropical-perroquets'
  };

  function showCartConfirmation(item) {
    if (!window.MesMemoiresCartNotice) {
      window.MesMemoiresCartNotice = (function() {
        var shell;
        function ensureShell() {
          if (shell) return shell;
          shell = document.createElement('div');
          shell.className = 'mm-cart-confirmation';
          shell.hidden = true;
          shell.innerHTML = [
            '<div class="mm-cart-confirmation__backdrop" data-mm-cart-close></div>',
            '<section class="mm-cart-confirmation__panel" role="dialog" aria-modal="true" aria-labelledby="mm-cart-confirmation-title">',
            '<button class="mm-cart-confirmation__close" type="button" data-mm-cart-close aria-label="Fermer">×</button>',
            '<p class="mm-cart-confirmation__kicker">Panier</p>',
            '<h2 id="mm-cart-confirmation-title">Produit ajouté au panier</h2>',
            '<p class="mm-cart-confirmation__item" data-mm-cart-item></p>',
            '<div class="mm-cart-confirmation__actions">',
            '<button class="btn btn--outline btn--3d" type="button" data-mm-cart-close>Continuer mes achats</button>',
            '<a class="btn btn--gold btn--3d" href="/cart">Voir le panier</a>',
            '</div>',
            '</section>'
          ].join('');
          shell.addEventListener('click', function(event) {
            if (event.target.closest('[data-mm-cart-close]')) {
              shell.hidden = true;
            }
          });
          document.body.appendChild(shell);
          return shell;
        }
        return {
          show: function(item) {
            var node = ensureShell();
            var label = node.querySelector('[data-mm-cart-item]');
            var title = item && (item.product_title || item.title);
            label.textContent = title ? title : 'Votre sélection a bien été ajoutée.';
            node.hidden = false;
            var continueButton = node.querySelector('[data-mm-cart-close]');
            if (continueButton) continueButton.focus({ preventScroll: true });
          }
        };
      })();
    }
    window.MesMemoiresCartNotice.show(item || null);
  }
  window.MesMemoiresShowCartConfirmation = showCartConfirmation;

  function variantMatchesFormat(variant, format){
    if (!format) return true;
    var haystack = normalize([variant.title, variant.option1, variant.option2, variant.option3].join(' '));
    return normalize(format).split(' ').filter(Boolean).every(function(part){
      if (part === 'petit') return haystack.indexOf('petit') !== -1;
      if (part === 'grand') return haystack.indexOf('grand') !== -1;
      if (part === 'duo') return haystack.indexOf('duo') !== -1 || haystack.indexOf('pack') !== -1;
      if (part === 'broche') return haystack.indexOf('broche') !== -1 || haystack.indexOf('broch') !== -1;
      if (part === 'spirale') return haystack.indexOf('spirale') !== -1 || haystack.indexOf('wire') !== -1;
      return haystack.indexOf(part) !== -1;
    });
  }

  function findVariant(product, format){
    if (!product || !Array.isArray(product.variants)) return null;
    var fixedVariantId = fixedPaidVariantIds[product.handle];
    if (fixedVariantId) {
      return product.variants.find(function(variant){
        return String(variant.id) === String(fixedVariantId);
      }) || { id: fixedVariantId };
    }
    var available = product.variants.filter(function(variant){ return variant.available; });
    if (!available.length) return null;
    return available.find(function(variant){ return variantMatchesFormat(variant, format); }) || available[0];
  }

  function productHandleFromUrl(url){
    try {
      var parts = new URL(url, window.location.origin).pathname.split('/').filter(Boolean);
      var index = parts.indexOf('products');
      return index !== -1 ? parts[index + 1] : '';
    } catch (error) {
      return '';
    }
  }

  function addVariantToCart(variantId){
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: Number(variantId), quantity: 1 })
    });
  }

  function enhanceNav(){
    document.querySelectorAll('.nav__links').forEach(function(links){
      if (!links.querySelector('a[href="/#carte-cadeau"]')) {
        var giftItem = document.createElement('li');
        giftItem.innerHTML = '<a href="/#carte-cadeau" class="nav__link">E-carte cadeau</a>';
        var collections = Array.from(links.querySelectorAll('a')).find(function(link){
          return /collections/i.test(link.getAttribute('href') || '') && /collections/i.test(link.textContent || '');
        });
        if (collections && collections.parentElement) collections.parentElement.insertAdjacentElement('afterend', giftItem);
        else links.insertBefore(giftItem, links.firstChild);
      }
      if (!links.querySelector('a[href="/cart"]')) {
        var cartItem = document.createElement('li');
        cartItem.innerHTML = '<a href="/cart" class="nav__link nav__cart" aria-label="Voir le panier">Panier</a>';
        var cta = links.querySelector('.nav__cta');
        if (cta && cta.parentElement) cta.parentElement.insertAdjacentElement('beforebegin', cartItem);
        else links.appendChild(cartItem);
      }
    });
  }

  function enhanceProductLinks(){
    document.addEventListener('click', function(event){
      var link = event.target.closest('a[href*="/products/"]');
      if (!link) return;
      var text = normalize(link.textContent);
      if (text.indexOf('ajouter au panier') === -1) return;

      var href = link.getAttribute('href') || '';
      var handle = productHandleFromUrl(href);
      if (!handle) return;

      event.preventDefault();
      if (link.getAttribute('aria-busy') === 'true') return;
      link.setAttribute('aria-busy', 'true');
      var originalText = link.textContent;
      link.textContent = 'Ajout au panier...';

      var fetchHandle = canonicalProductHandles[handle] || handle;
      fetch('/products/' + encodeURIComponent(fetchHandle) + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function(response){
          if (!response.ok) throw new Error('product-not-found');
          return response.json();
        })
        .then(function(product){
          var variant = findVariant(product, selectedFormatFromUrl(href));
          if (!variant) throw new Error('variant-not-found');
          return addVariantToCart(variant.id);
        })
        .then(function(response){
          if (!response.ok) throw new Error('cart-add-failed');
          return response.json();
        })
        .then(function(item){
          link.removeAttribute('aria-busy');
          link.textContent = originalText;
          showCartConfirmation(item);
        })
        .catch(function(){
          link.removeAttribute('aria-busy');
          link.textContent = originalText;
          window.location.href = href;
        });
    });
  }

  function bindAjaxCartForms() {
    document.querySelectorAll('form').forEach(function(form) {
      var action = form.getAttribute('action') || '';
      if (form.dataset.ajaxCartBound === 'true') return;
      if (!/\/cart\/add/i.test(action)) return;
      if (form.classList.contains('cart-form')) return;
      form.dataset.ajaxCartBound = 'true';

      form.addEventListener('submit', function(event) {
        event.preventDefault();
        var submitter = event.submitter || form.querySelector('button[type="submit"], input[type="submit"]');
        var originalText = submitter && 'textContent' in submitter ? submitter.textContent : '';
        if (submitter) {
          submitter.setAttribute('aria-busy', 'true');
          if ('textContent' in submitter) submitter.textContent = 'Ajout au panier...';
        }

        var body = new FormData(form);
        body.delete('return_to');
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: body
        })
          .then(function(response) {
            if (!response.ok) throw new Error('cart-add-failed');
            return response.json();
          })
          .then(function(item) {
            if (submitter) {
              submitter.removeAttribute('aria-busy');
              if ('textContent' in submitter && originalText) submitter.textContent = originalText;
            }
            showCartConfirmation(item);
          })
          .catch(function() {
            form.submit();
          });
      });
    });
  }

  function syncFormatSelectors(){
    document.querySelectorAll('[data-format-selector]').forEach(function(zone){
      var select = zone.querySelector('.product-format-select');
      if (!select) return;
      var product = zone.closest('.multi-format-product, .amp-product, .coll-book');
      var buy = product ? product.querySelector('.product-buy-link, .amp-buy a, .coll-buy a') : null;
      var price = product ? product.querySelector('.product-current-price, .amp-current-price, .coll-price') : null;
      var details = zone.querySelectorAll('[data-format-detail]');
      function applySelection(){
        var option = select.options[select.selectedIndex];
        if (!option) return;
        if (buy && option.dataset.cartUrl) buy.setAttribute('href', option.dataset.cartUrl);
        if (price && option.dataset.price) price.textContent = option.dataset.price;
        details.forEach(function(detail){
          detail.classList.toggle('is-active', detail.dataset.formatDetail === option.value);
        });
      }
      select.addEventListener('change', applySelection);
      applySelection();
    });
  }

  ready(function(){
    enhanceNav();
    syncFormatSelectors();
    enhanceProductLinks();
    bindAjaxCartForms();
  });
})();

// Galerie immersive premium pour les visuels editoriaux
(function initPremiumGalleryModal(){
  function ready(fn){
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  ready(function(){
    var triggers = document.querySelectorAll('[data-gallery-src]');
    if (!triggers.length) return;

    var modal = document.createElement('div');
    modal.className = 'premium-gallery-modal';
    modal.id = 'premiumGalleryModal';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-label', 'Apercu grand format');
    modal.hidden = true;
    modal.innerHTML = [
      '<div class="premium-gallery-modal__backdrop" data-gallery-close></div>',
      '<div class="premium-gallery-modal__frame">',
      '<img class="premium-gallery-modal__image" alt="">',
      '<p class="premium-gallery-modal__notice" hidden>Image non contractuelle</p>',
      '</div>',
      '<button class="premium-gallery-modal__close" type="button" aria-label="Fermer le visuel" data-gallery-close>&times;</button>'
    ].join('');
    document.body.appendChild(modal);

    var image = modal.querySelector('.premium-gallery-modal__image');
    var notice = modal.querySelector('.premium-gallery-modal__notice');
    var closeItems = modal.querySelectorAll('[data-gallery-close]');
    var lastFocus = null;
    var previousOverflow = '';
    var closeTimer = null;

    function openGallery(trigger){
      var src = trigger.getAttribute('data-gallery-src');
      if (!src) return;
      var triggerImg = trigger.querySelector('img');
      var alt = trigger.getAttribute('data-gallery-alt') || (triggerImg ? triggerImg.alt : '') || '';
      lastFocus = document.activeElement;
      previousOverflow = document.body.style.overflow || '';
      window.clearTimeout(closeTimer);
      image.src = src;
      image.alt = alt;
      var needsNotice = trigger.getAttribute('data-gallery-notice') === 'true' ||
        trigger.classList.contains('cover-example-card__button') ||
        /couvertures-personnalisees/i.test(src) ||
        /pourquoi-nos-creations-sont-uniques/i.test(src);
      if (notice) notice.hidden = !needsNotice;
      modal.hidden = false;
      document.body.classList.add('premium-gallery-open');
      document.body.style.overflow = 'hidden';
      requestAnimationFrame(function(){
        modal.classList.add('is-open');
        var closeBtn = modal.querySelector('.premium-gallery-modal__close');
        if (closeBtn) closeBtn.focus({ preventScroll: true });
      });
    }

    function closeGallery(){
      if (modal.hidden) return;
      modal.classList.remove('is-open');
      document.body.classList.remove('premium-gallery-open');
      document.body.style.overflow = previousOverflow;
      closeTimer = window.setTimeout(function(){
        modal.hidden = true;
        image.removeAttribute('src');
        image.alt = '';
        if (notice) notice.hidden = true;
        if (lastFocus && typeof lastFocus.focus === 'function') {
          lastFocus.focus({ preventScroll: true });
        }
      }, 280);
    }

    document.addEventListener('click', function(event){
      var trigger = event.target.closest('[data-gallery-src]');
      if (!trigger) return;
      event.preventDefault();
      openGallery(trigger);
    });

    closeItems.forEach(function(item){
      item.addEventListener('click', closeGallery);
    });

    modal.addEventListener('click', function(event){
      var frame = modal.querySelector('.premium-gallery-modal__frame');
      var closeBtn = modal.querySelector('.premium-gallery-modal__close');
      if (frame && frame.contains(event.target)) return;
      if (closeBtn && closeBtn.contains(event.target)) return;
      closeGallery();
    });

    document.addEventListener('keydown', function(event){
      if (event.key === 'Escape' && !modal.hidden) closeGallery();
    });
  });
})();

// Lecture grand format des temoignages
(function initTestimonialModal(){
  function ready(fn){
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  ready(function(){
    var buttons = document.querySelectorAll('.testimonial-card__open');
    if (!buttons.length) return;

    var modal = document.createElement('div');
    modal.className = 'testimonial-modal';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-label', 'Temoignage en grand');
    modal.hidden = true;
    modal.innerHTML = [
      '<div class="testimonial-modal__backdrop" data-testimonial-close></div>',
      '<article class="testimonial-modal__panel" tabindex="-1">',
      '<button class="testimonial-modal__close" type="button" aria-label="Fermer le temoignage" data-testimonial-close>&times;</button>',
      '<div class="testimonial-modal__quote" aria-hidden="true">"</div>',
      '<p class="testimonial-modal__text"></p>',
      '<p class="testimonial-modal__author"></p>',
      '</article>'
    ].join('');
    document.body.appendChild(modal);

    var panel = modal.querySelector('.testimonial-modal__panel');
    var text = modal.querySelector('.testimonial-modal__text');
    var author = modal.querySelector('.testimonial-modal__author');
    var closeItems = modal.querySelectorAll('[data-testimonial-close]');
    var lastFocus = null;
    var closeTimer = null;

    function openModal(card){
      if (!card) return;
      var cardText = card.querySelector('.testimonial-card__text');
      var cardAuthor = card.querySelector('.testimonial-card__author');
      if (!cardText || !cardAuthor) return;

      window.clearTimeout(closeTimer);
      lastFocus = document.activeElement;
      text.textContent = cardText.textContent || '';
      author.textContent = cardAuthor.textContent || '';
      modal.hidden = false;
      document.body.classList.add('testimonial-modal-open');

      requestAnimationFrame(function(){
        modal.classList.add('is-open');
        if (panel) panel.focus({ preventScroll: true });
      });
    }

    function closeModal(){
      if (modal.hidden) return;
      modal.classList.remove('is-open');
      document.body.classList.remove('testimonial-modal-open');
      closeTimer = window.setTimeout(function(){
        modal.hidden = true;
        text.textContent = '';
        author.textContent = '';
        if (lastFocus && typeof lastFocus.focus === 'function') {
          lastFocus.focus({ preventScroll: true });
        }
      }, 280);
    }

    buttons.forEach(function(button){
      button.addEventListener('click', function(){
        openModal(button.closest('.testimonial-card'));
      });
    });

    closeItems.forEach(function(item){
      item.addEventListener('click', closeModal);
    });

    modal.addEventListener('click', function(event){
      if (panel && panel.contains(event.target)) return;
      closeModal();
    });

    document.addEventListener('keydown', function(event){
      if (event.key === 'Escape' && !modal.hidden) closeModal();
    });
  });
})();
